import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import cn from 'classnames';

import { Badge } from './badge';
import { H6 } from './text';
import { IFeaturedImage } from '../models/featured-image';

interface IProps {
	title: string;
	coverImage?: IFeaturedImage;
	baseSlug: string;
	slug: string;
	badge?: string;
	excerpt?: string;
	light?: boolean;
}

export default function VideoSliderItem({
	title,
	coverImage,
	baseSlug,
	slug,
	excerpt,
	badge,
	light,
}: IProps) {
	const textClassNames = cn({
		'text-white': light,
		'hover:underline': true,
	});

	return (
		<section className="mb-0">
			<div className="flex flex-col bg-transparent mb-4 h-auto overflow-hidden rounded-sm">
				{coverImage && (
					<Link href={`/${baseSlug}/${slug}`}>
						<Image
							width={1280}
							height={720}
							alt={title}
							src={coverImage?.node.sourceUrl}
							className="aspect-video object-cover rounded-t-sm hover:opacity-75 transition-opacity"
						/>
					</Link>
				)}
			</div>
			{badge && <Badge className="mb-2">{badge}</Badge>}
			<div className="pl-0 pr-4 pt-2 pb-0">
				<H6 className="mb-2">
					<Link
						href={`/${baseSlug}/${slug}`}
						className={textClassNames}
						dangerouslySetInnerHTML={{ __html: title }}
					></Link>
				</H6>
				{excerpt && (
					<div
						className="block md:hidden line-clamp-2"
						dangerouslySetInnerHTML={{ __html: excerpt }}
					/>
				)}
			</div>
		</section>
	);
}
